export default __webpack_public_path__ + "static/media/doctor5.1ea2864c.png";